import { useFormContext } from "react-hook-form";

const useClearField = () => {
  const { resetField } = useFormContext();

  return (field: string | Array<string>): void => {
    if (typeof field === "string") {
      resetField(field);
    } else {
      field.forEach((value) => resetField(value));
    }
  };
};

export default useClearField;
